import { DEFAULT, match } from '@/utils/pattern-match-util'
import type {
  LegendSettingsResource,
  RatingConfigResource,
} from '@/features/jobs/api/resources/legend'
import type {
  LegendSettingsProps,
  RatingConfig,
} from '@/features/jobs/legends/LegendSettings'
import { mapServiceTypeResourceToServiceType } from '@/features/jobs/legends/published-legend-mappers'

export function mapLegendSettingResourcesToProps(
  resource: LegendSettingsResource,
): LegendSettingsProps {
  return {
    id: resource.id,
    version: resource.version,
    imageUrl: resource.image_url,
    name: resource.name,
    ratingConfig: mapRatingConfigResourceToRatingConfig(resource.rating_config),
    workspaceId: resource.workspace_id,
    serviceType: mapServiceTypeResourceToServiceType(resource.service_type),
  }
}

export function mapRatingConfigResourceToRatingConfig(
  ratingConfig: RatingConfigResource,
): RatingConfig {
  return {
    proRatingEnabled: ratingConfig.proRatingEnabled,
    platformRatingEnabled: ratingConfig.platformRatingEnabled,
    customerRatingMethod: match(ratingConfig.customerRatingMethod, {
      thumbs: 'Thumb',
      stars: 'Star',
      [DEFAULT]: 'Star',
    }),
  }
}
